import type { ServiceItem } from '@/cms/fields/types/checkout-page'
import { BusService } from '@/scopes/checkout/components/services/BusService'
import { CancellationInsuranceService } from '@/scopes/checkout/components/services/CancellationInsuranceService'
import { SweaterService, TShirtService } from '@/scopes/checkout/components/services/ClothingService'
import { GenericService } from '@/scopes/checkout/components/services/GenericService'
import { MealplanDPService } from '@/scopes/checkout/components/services/MealplanDPService'
import { TravelInsuranceService } from '@/scopes/checkout/components/services/TravelInsuranceService'
import React from 'react'

const genericServiceMap = {
  'BUS': BusService,
  'TSHIRT*': TShirtService,
  'SWEATER*': SweaterService,
  'ACCOMMODATION': MealplanDPService,
  'TRAVEL*': TravelInsuranceService,
  'CANCEL*': CancellationInsuranceService,
}

export function getGenericServiceComponent(aName: string, item: ServiceItem, type: string, index: number) {
  const key = `${type}-${aName}-${index}`

  for (const [pattern, Component] of Object.entries(genericServiceMap)) {
    const isMatch = aName.startsWith(pattern.replace('*', '')) || aName === pattern
    if (!isMatch)
      continue

    return <Component item={item} key={key} />
  }
  return <GenericService item={item} key={key} />
}
